import type React from 'react'

import { TextAligning } from 'atoms/TextBox'
import { TextBoxFontXs, TextBoxMaxLine1FontXl } from 'atoms/TextBox/Templates'
import { ChildrenWithDividers } from 'containers/ChildrenWithDividers'
import {
  MaxVideoQualityBodySC,
  MaxVideoQualitySC,
} from './MaxVideoQuality.styled'

export interface IMaxVideoQuality {
  title: string
  description: string
  children: React.ReactNode
}

export const MaxVideoQuality = ({
  title,
  description,
  children,
}: IMaxVideoQuality) => {
  return (
    <MaxVideoQualitySC>
      <TextBoxMaxLine1FontXl title={title} />

      <ChildrenWithDividers Container={MaxVideoQualityBodySC}>
        {children}
      </ChildrenWithDividers>

      <TextBoxFontXs title={description} alignment={TextAligning.Left} />
    </MaxVideoQualitySC>
  )
}
